import React, { FC, useState } from "react";
import FirstEducation from "./Tabs/FirstEducation";
import SecondEducation from "./Tabs/SecondEducation";
import WorkSkills from "./Tabs/WorkSkills";
import PostgraduateEducation from "./Tabs/PostgraduateEducation";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const educationTabs = [
  {
    title: "Первое образование",
    component: <FirstEducation />,
  },
  {
    title: "Второе образование",
    component: <SecondEducation/>,
  },
  {
    title: "Навыки работы",
    component: <WorkSkills/>
  },
  {
    title: "Послевузовское профессиональное образование",
    component: <PostgraduateEducation/>
  }
];


const Education: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {educationTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {educationTabs[tab].component}
    </Wrapper>
  );
};

export default Education;
